/**
 * V222 (C-03/C-17) — aviso de facturación del banner, puro (lo prueba vitest). El backend
 * lo manda en `me.tenant.cfdiNotice` solo al SUPER_USER:
 *  - global_sin_emisor: factura global encendida con el emisor CFDI no listo (las ventas
 *    del periodo se quedarían sin CFDI) — rojo;
 *  - csd_vencido: el CSD de un emisor activo venció (no se puede timbrar nada) — rojo;
 *  - csd_por_vencer: el CSD vence en ≤ 30 días — ámbar.
 */
export type CfdiNotice =
  | { kind: 'global_sin_emisor'; missing: string[] }
  | { kind: 'csd_vencido'; validTo: string }
  | { kind: 'csd_por_vencer'; validTo: string };

/** Mismas etiquetas que el backend (`issuer-readiness.ts`), en corto para el banner. */
export const ISSUER_MISSING_SHORT: Record<string, string> = {
  perfil: 'los datos fiscales del emisor',
  csd: 'tu CSD (sellos digitales)',
  csd_vencido: 'renovar tu CSD (ya venció)',
  manifiesto: 'firmar el manifiesto',
  candado: 'que FluidSol active tu facturación',
};

export function describeMissing(codes: string[]): string {
  const labels = codes.map((c) => ISSUER_MISSING_SHORT[c] ?? c);
  if (labels.length <= 1) return labels.join('');
  return `${labels.slice(0, -1).join(', ')} y ${labels[labels.length - 1]}`;
}

const fmt = (iso: string) => new Date(iso).toLocaleDateString('es-MX');

export function cfdiNoticeView(n: CfdiNotice | null | undefined): { tone: 'rose' | 'amber'; text: string } | null {
  if (!n) return null;
  if (n.kind === 'global_sin_emisor') {
    return {
      tone: 'rose',
      text: `Tu factura global está activada, pero tu emisor CFDI no está listo (falta: ${describeMissing(n.missing)}). `
        + 'Las ventas de este periodo no se van a facturar hasta que lo completes en Configuración → Emisor CFDI, o desactiva la factura global.',
    };
  }
  if (n.kind === 'csd_vencido') {
    return {
      tone: 'rose',
      text: `Tu CSD venció el ${fmt(n.validTo)}: no se puede timbrar ninguna factura hasta que subas uno nuevo en Configuración → Emisor CFDI.`,
    };
  }
  return {
    tone: 'amber',
    text: `Tu CSD vence el ${fmt(n.validTo)}. Renuévalo en el SAT y súbelo en Configuración → Emisor CFDI para no dejar de facturar.`,
  };
}
